require('bijou/base')

$.widget "chopin.direct_debit_form", $.bijou.base,
  _show_form: ->
    applicableFieldsForPersonal =
      @element.find(".js-toggleable-field[data-show='business_type_personal']")
        .closest('.control-block')

    applicableFieldsForCompany =
      @element.find(".js-toggleable-field[data-show='business_type_company']")
        .closest('.control-block')

    accountHolderEl = @element.find('.js-account-holder')
    policyHolderName = accountHolderEl.data('policy-holder')

    businessTypeEl = @element.find('.js-business-type')
    sortCodeEl = @element.find('.sortcode')

    residential_addressEl = @element.find('.direct-debit-residential-address')
    correct_residential_addressEl = @element.find('.js-correct-address')

    if businessTypeEl.val() != 'Sole trader'
      @._hideFields(applicableFieldsForPersonal)
      @._toggleAccHolderErrorMessage(true)
      @._showFields(applicableFieldsForCompany)
      accountHolderEl.prop('readonly', false).removeClass('readonly')
      accountHolderEl.val('')
    else
      @._hideFields(applicableFieldsForCompany)
      @._toggleAccHolderErrorMessage(false)
      @._showFields(applicableFieldsForPersonal)
      accountHolderEl.prop('readonly', true).addClass('readonly')
      accountHolderEl.val(policyHolderName)

    if residential_addressEl.length
      if businessTypeEl.val() in ['Sole trader', 'Partnership']
        residential_addressEl.removeClass('hidden')
      else
        residential_addressEl.addClass('hidden')

    dobEl = @element.find('.js-date-of-birth')
    if dobEl.length && businessTypeEl.is('select')
      dobContainer = dobEl.closest('.date_of_birth')
      if businessTypeEl.val() == 'Limited company'
        dobContainer.addClass('hidden')
        dobEl.val('').attr('disabled', true)
      else
        dobContainer.removeClass('hidden')
        dobEl.attr('disabled', false)

    if correct_residential_addressEl.val() == 'true' || correct_residential_addressEl.val() == ''
      address_lookup = residential_addressEl.find("#address-lookup")
      address_lookup.addClass('hidden')
    else
      address_lookup = residential_addressEl.find("#address-lookup")
      address_lookup.removeClass('hidden')

  _create: ->
    businessTypeEl = @element.find('.js-business-type')
    sortCodeEl = @element.find('.sortcode')
    dobEl = @element.find('.js-date-of-birth')

    correctResidentialAddressEl = @element.find('.js-correct-address')

    @._show_form()
    @._addDobValidation(dobEl) if dobEl.length

    businessTypeEl.on 'change', =>
      @._show_form()

    correctResidentialAddressEl.on 'change', =>
      @._show_form()

    sortCodeEl.on 'keyup', (e) ->
      el = e.target
      if el.value.length == 2 && $.isNumeric(e.key)
        $(el).nextAll('.sortcode').eq(0).focus()

  _addDobValidation: (dobEl) ->
    today = new Date()
    maxDob = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())
    minDob = new Date(today.getFullYear() - 110, today.getMonth(), today.getDate())

    # Ensure a validator instance exists on the form before adding rules
    form = if @element.is('form') then @element else @element.closest('form')
    form.validate() unless form.data('validator')

    dateFormat = dobEl.data('dateFormat') || 'en-GB'

    dobEl.rules 'add',
      date: true
      mindate: @._formatDate(minDob, dateFormat)
      maxdate: @._formatDate(maxDob, dateFormat)
      messages:
        date: 'Incorrect date format, please provide date in DD/MM/YYYY'
        mindate: 'Account holders must be under 110'
        maxdate: 'Account holders must be over 18'

  _formatDate: (date, dateFormat) ->
    day = ('0' + date.getDate()).slice(-2)
    month = ('0' + (date.getMonth() + 1)).slice(-2)
    year = date.getFullYear()
    if dateFormat == 'en-US'
      "#{month}/#{day}/#{year}"
    else
      "#{day}/#{month}/#{year}"

  _hideFields: (fields) ->
    fields
      .addClass('off')
      .find('input')
      .attr('disabled', true)

  _toggleAccHolderErrorMessage: (bool) ->
    @element.find('#direct_debit_form_account_holder_name-error').toggle(bool)

  _showFields: (fields) ->
    fields
      .removeClass('off')
      .find('input')
      .attr('disabled', false)

  _setupSoleTraderForm: (applicableFieldsForCompany,
    applicableFieldsForPersonal,
    policyHolderName,
    accountHolderEl) ->
      @._hideFields(applicableFieldsForCompany)
      @._toggleAccHolderErrorMessage(false)
      @._showFields(applicableFieldsForPersonal)
      accountHolderEl.prop('readonly', true).addClass('readonly')
      accountHolderEl.val(policyHolderName)

$ ->
  $("[data-module=direct_debit_form]").direct_debit_form()
